<my-feedback
  [title]="type=='editor' ? '编辑岗位' : '创建岗位'"
  [show]='show'
  [body]='editDutiesTpl'
  [directClose]='false'
  (cancel)='cancelEditorDuties()'
  (sure)='editorDuties()'
>
  <ng-template #editDutiesTpl>
    <div
      class='create-duties-box flexColumn'
    >
      <!--      如果岗位模板不为空-->
      <ng-container *ngIf="dutiesTpl.length > 0 || type=='editor'">
        <!--    配置信息-->
        <div class='conf-box flexColumn flexFull'>
          <!--        选择创建岗位的方式自定义还是模板-->
          <!--        <div class='manage-duties-box flexRow' *ngIf="type=='create'">-->
          <!--          <div class='flexFull'></div>-->
          <!--          <label class='info-label mr-xs'>添加方式:</label>-->
          <!--          <radio-button-->
          <!--            [data]='dutiesTypeOptions'-->
          <!--            [(check)]='dutiesType'-->
          <!--            [checkPoint]='false'-->
          <!--            [itemStyle]="{ width: '169px', 'margin-bottom': 0 }"-->
          <!--            (checkChange)='checkTplType($event)'-->
          <!--          ></radio-button>-->
          <!--          <div class='flexFull'></div>-->
          <!--        </div>-->
          <!--        选择创建岗位的方式自定义还是模板 end-->
          <!--      管理岗-->
          <!--        岗位名称-->
          <div class='manage-duties-box flexRow' *ngIf="type=='editor'">
            <div class='flexFull'></div>
            <label class='info-label'>岗位名称:</label>
            <nz-input-group [nzSuffix]='nameClearTpl' style='width: 338px; margin-left: 4px' class='selfRadius'>
              <input nz-input [(ngModel)]="duties['job_name']" placeholder='输入岗位名称' maxlength='10'
                     [disabled]='true' />
            </nz-input-group>
            <ng-template #nameClearTpl>
              <i
                nz-icon
                class='ant-input-clear-icon'
                nzTheme='fill'
                nzType='close-circle'
                *ngIf="duties['job_name']"
                (click)="duties['job_name'] = ''"
              ></i>
            </ng-template>
            <div class='flexFull'></div>
          </div>
          <!--        岗位名称-->
          <!--      岗位用人标尺-->
          <div class='duties-standard-box flexRow' *ngIf="type=='editor'">
            <div class='flexFull'></div>
            <label class='info-label'>用人标尺:</label>
            <nz-select
              [(ngModel)]="duties['rule_id']"
              nzMode='default'
              nzPlaceHolder='选择用人标尺'
              style='width: 338px; margin-left: 4px'
              [disabled]='true'
            >
              <ng-container *ngFor='let item of standard'>
                <nz-option nzCustomContent [nzValue]="item['id']" [nzLabel]="item['name']">
                  <div [ngClass]="{ selectCheck: duties['rule_id'] == item['id'] }">{{ item['name'] }}</div>
                </nz-option>
              </ng-container>
            </nz-select>
            <div class='flexFull'></div>
          </div>
          <!--      适应期-->
          <div class='manage-duties-box flexRow' *ngIf="type=='editor'">
            <div class='flexFull'></div>
            <label class='info-label'>适应期:</label>
            <nz-input-number [(ngModel)]="duties['adapt']" placeholder='输入数字' maxlength='3' [nzMin]='0'
                             [nzMax]='90' class='number_input ' [nzStep]='1'
                             [disabled]='true'></nz-input-number>
            <div style='width: 186px; text-align: left; text-indent: 4px'>天</div>
            <div class='flexFull'></div>
          </div>
          <!--      选择岗位模板-->
          <div class='duties-standard-box flexRow' *ngIf="type=='create'">
            <div class='flexFull'></div>
            <label class='info-label'>岗位名称:</label>
            <nz-select nzMode='multiple'
                       [(ngModel)]='templete_id'
                       nzMaxTagCount='2'
                       nzPlaceHolder='选择岗位模板'
                       style='width: 338px; margin-left: 4px'
                       (ngModelChange)='checkTpl($event)'
            >
              <ng-container *ngFor='let item of dutiesTpl'>
                <nz-option nzCustomContent [nzValue]="item['templete_job_id']" [nzLabel]="item['job_name']">
                  <div [ngClass]="{ 'selectCheck': templete_id.indexOf(item['templete_job_id']) >-1 }">
                    {{ item['job_name'] }}
                  </div>
                </nz-option>
              </ng-container>
            </nz-select>
            <div class='flexFull'></div>
          </div>
          <!--      设为主岗位-->
          <div class='manage-duties-box flexRow'>
            <div class='flexFull'></div>
            <label class='info-label'>设为管理:</label>
            <nz-switch [ngModel]="duties['is_admin'] == 1" class='ml-xs'
                       (ngModelChange)='setAdminDuties($event)' [nzDisabled]='templete_id.length > 1'></nz-switch>
            <div style='width: 300px; text-align: left; text-indent: 4px'></div>
            <div class='flexFull'></div>
          </div>
        </div>
      </ng-container>
      <!--    如果岗位模板不为空 End -->
      <!--    如果岗位模板为空 -->
      <ng-container *ngIf="dutiesTpl.length == 0 && type=='create'">
        <div class='width-100 text-center'>
          <img src='assets/no-data.png' style='width:123px;height:99px;' />
          <div class='text-gray1 mt-md'>
            暂无可选岗位，请前往
            <i class='text-primary clickEle ' (click)='jumpToTpl()'>模板岗位</i>
            中设置
          </div>
        </div>
      </ng-container>
      <!--    如果岗位模板为空 End-->
    </div>
  </ng-template>
</my-feedback>
